var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 6,
    viewBox: "0 0 10 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28033 0.21967C8.98744 -0.0732236 8.51256 -0.0732236 8.21967 0.21967L4.75 3.68934L1.28033 0.21967C0.987437 -0.0732236 0.512563 -0.0732236 0.21967 0.21967C-0.0732234 0.512563 -0.0732233 0.987437 0.21967 1.28033L4.21967 5.28033C4.51256 5.57322 4.98744 5.57322 5.28033 5.28033L9.28033 1.28033C9.57322 0.987437 9.57322 0.512563 9.28033 0.21967Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.f704031da9386329da721006574d58db.svg";
export { ForwardRef as ReactComponent };